import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "admin-page-wr" }
const _hoisted_2 = {
  key: 0,
  class: "dashboard-header"
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "info-wr" }
const _hoisted_5 = { class: "block" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row-value" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "row-value" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "row-value" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "row-value" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "row-value" }
const _hoisted_16 = { class: "subtitle-main" }
const _hoisted_17 = { class: "filters" }
const _hoisted_18 = { class: "table-wrapper" }
const _hoisted_19 = { class: "table-default" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "bold" }
const _hoisted_22 = { class: "status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "title-main" }, "Customer Summary", -1)),
          _createElementVNode("div", { class: "edit-buttons" }, [
            _createElementVNode("button", {
              class: "button default edit",
              onClick: $setup.toEditUserDetails
            }, "Edit Company"),
            _createElementVNode("button", {
              class: "button default edit",
              onClick: $setup.toEditUser
            }, "Edit Administrator")
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title" }, "Company Name:", -1)),
                  _createElementVNode("div", _hoisted_7, _toDisplayString((typeof $setup.user.detailsId !== "string" && $setup.user.detailsId?.companyName) || "-"), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-title" }, "Administrator:", -1)),
                  _createElementVNode("div", _hoisted_9, _toDisplayString($setup.getFirstLastName($setup.user)), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-title" }, "Email:", -1)),
                  _createElementVNode("div", _hoisted_11, _toDisplayString($setup.user.email), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-title" }, "Phone:", -1)),
                  _createElementVNode("div", _hoisted_13, _toDisplayString($setup.user.phone), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-title" }, "Chargebee ID:", -1)),
                  _createElementVNode("div", _hoisted_15, _toDisplayString($setup.user.detailsId && typeof $setup.user.detailsId === "object" && "chargebeeCustomerId" in $setup.user.detailsId ? $setup.user.detailsId.chargebeeCustomerId || "-" : "-"), 1)
                ])
              ])
            ])
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "title-main" }, "Projects", -1)),
          _createElementVNode("h3", _hoisted_16, _toDisplayString(`${$setup.estates.length} project${$setup.estates.length > 1 ? "s" : ""}`), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createVNode($setup["InputSearch"], {
        modelValue: $setup.searchQuery,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchQuery) = $event)),
        placeholder: "Search",
        theme: "filter"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", { class: "buttons" }, [
        _createElementVNode("button", {
          class: "button default primary add-btn-primary",
          onClick: $setup.toCreateEstate
        }, "Add Project")
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("table", _hoisted_19, [
        _cache[10] || (_cache[10] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "Project Name"),
            _createElementVNode("th", null, "Status"),
            _createElementVNode("th", null, "Type"),
            _createElementVNode("th", null, "Add-ons")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.estates, (estate) => {
            return (_openBlock(), _createElementBlock("tr", {
              onClick: ($event: any) => ($setup.toEstate(estate._id))
            }, [
              _createElementVNode("td", _hoisted_21, _toDisplayString(estate.title), 1),
              _createElementVNode("td", _hoisted_22, _toDisplayString(estate.isActive ? "Active" : "Draft"), 1),
              _createElementVNode("td", null, _toDisplayString($setup.getEstateType(estate)), 1),
              _createElementVNode("td", null, _toDisplayString($setup.getAddOns(estate)), 1)
            ], 8, _hoisted_20))
          }), 256))
        ])
      ])
    ]),
    _createVNode($setup["ConfirmDeleteModal"], {
      isOpen: $setup.showConfirmDeleteModal,
      deleteItem: $setup.itemForDelete.title,
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.showConfirmDeleteModal = false)),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => ($setup.deleteEstate($setup.itemForDelete.id)))
    }, null, 8, ["isOpen", "deleteItem"])
  ]))
}